// extracted by mini-css-extract-plugin
module.exports = {"esrb":"ESRB_esrb__1uptq"};